<template>
  <div>
    <div class="d-flex flex-wrap align-center mb-2" style="gap: 12px">
      <v-btn-toggle v-model="stockFilter" mandatory dense color="primary">
        <v-btn small value="all">Все</v-btn>
        <v-btn small value="in_stock">С остатком</v-btn>
        <v-btn small value="out">Закончились</v-btn>
      </v-btn-toggle>
      <v-text-field
        v-model="search" label="Поиск теста" append-icon="mdi-magnify"
        outlined dense hide-details clearable style="max-width: 260px"
      />
    </div>

    <v-data-table
      :headers="headers"
      :items="rows"
      item-key="code"
      disable-pagination
      hide-default-footer
      disable-sort
      no-data-text="Тестов не найдено"
    >
      <template v-slot:item.name="{ item }">
        <b>{{ item.name }}</b>
        <span v-if="item.amount <= 0" class="ended-tag">Закончилась</span>
      </template>
      <template v-slot:item.amount="{ item }">
        <b>{{ item.amount }}</b>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// Остатки менеджера по тестам в том же виде, что у корпа: фильтр «Все / С остатком / Закончились», поиск, метка «Закончилась».
export default {
  name: 'ManagerTestsTable',
  props: {
    // { code, name, amount, received, spent }
    items: { type: Array, default: () => [] },
    // Получено и израсходовано показываем, только если сервер отдал счётчики
    withCounters: { type: Boolean, default: false },
  },
  data: () => ({
    stockFilter: 'all',
    search: '',
  }),
  computed: {
    headers() {
      return [
        { text: 'Тест', value: 'name' },
        { text: 'Мой остаток', value: 'amount', align: 'end' },
        ...(this.withCounters ? [
          { text: 'Получено', value: 'received', align: 'end' },
          { text: 'Израсходовано', value: 'spent', align: 'end' },
        ] : []),
      ];
    },
    rows() {
      const query = (this.search || '').trim().toLowerCase();
      return this.items
        .filter((item) => {
          if (this.stockFilter === 'in_stock') return item.amount > 0;
          if (this.stockFilter === 'out') return item.amount <= 0;
          return true;
        })
        .filter((item) => !query || item.name.toLowerCase().includes(query));
    },
  },
};
</script>

<style scoped lang="scss">
.ended-tag {
  margin-left: 6px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  background: #fff8e1;
  color: #f57f17;
}
</style>
